export interface AdminLoadingStateProps {
  label?: string;
}

export function AdminLoadingState({ label = 'Loading' }: AdminLoadingStateProps) {
  return (
    <div className="flex items-center justify-center gap-3 px-4 py-10" role="status">
      <div
        className="border-brand h-6 w-6 animate-spin rounded-full border-2 border-t-transparent motion-reduce:animate-none"
        aria-hidden="true"
      />
      <span className="text-sm text-gray-500">{label}</span>
    </div>
  );
}
